import './js/fetchApi';
import './js/shoppingList';
import './js/formSignUp';
import './js/mobileMenu';
import './js/themeSwitch';
import './js/slider';
